import React from 'react';
import { LightBulbIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';

const ResettingBehavioursFinalThoughts = () => {
  return (
    <div className="space-y-8">
      <PlaybookSection
        title="Final Thoughts"
        icon={<LightBulbIcon className="h-7 w-7 text-primary-light" />}
      >
        <PlaybookCard>
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-4">
              Addressing and realigning behaviours to reflect your company's core values is not a one-time fix, but an ongoing journey. As a People Leader, your role is crucial in setting the tone and leading by example. By openly addressing issues, deeply understanding the root causes (if applicable), and continuously reinforcing your org's core values, you foster a culture of trust, collaboration, and high performance.
            </p>
          </div>
        </PlaybookCard>
      </PlaybookSection>
    </div>
  );
};

export default ResettingBehavioursFinalThoughts; 